import { Base } from '@studiometa/js-toolkit';
import { loadStoreLocatorReference } from './StoreReferencePoint.js';
import { haversineDistanceKm, formatDistance } from './StoreDistance.js';

/**
 * Distance affichée sur la page magasin, à côté du badge de type (chantier
 * store-locator-revendeurs, point 7, critère 12, scénarios 38-39b).
 *
 * La distance n'est affichée que si le visiteur arrive depuis une recherche
 * ou une géolocalisation sur « Nos revendeurs » : `loadStoreLocatorReference()`
 * lit la clé dédiée `sessionStorage` (`ndStoreLocatorRef`, voir
 * `StoreReferencePoint.js`), propre à l'onglet — jamais les clés du magasin de
 * retrait, jamais un cookie. Sans point de référence (lien direct, nouvel
 * onglet, navigateur fermé), rien n'est ajouté au DOM : aucune valeur
 * inventée (scénario 39, 39b).
 */
export default class StoreDistanceBadge extends Base {
  static config = {
    name: 'StoreDistanceBadge',
    options: {
      lat: Number,
      lng: Number,
    },
  };

  mounted() {
    const { lat, lng } = this.$options;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return;
    }

    const reference = loadStoreLocatorReference();
    if (!reference) {
      return;
    }

    const distanceKm = haversineDistanceKm(reference, { lat, lng });
    const formatted = formatDistance(distanceKm);
    if (!formatted) {
      return;
    }

    const distanceEl = document.createElement('span');
    distanceEl.className = 'store-hero__distance';
    distanceEl.textContent = formatted;
    this.$el.appendChild(distanceEl);
  }
}
